import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import AgentLayoutIndex from '../_layouts/index'

declare var window: interfaces.IWindow

interface IProps {
  agent_roles: {
    agent_roles: IJsonResponse
  }
  user: any
}

const COLUMNS = [
  { name: I18n.t('generic.name'), field: 'name', required: true },
  { name: I18n.t('generic.description'), field: 'description', required: false },
  { name: I18n.t('generic.status'), field: 'status_label', required: false },
]

const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'disabled', label: 'Disabled' },
]

const AgentRolesIndex: React.FC<IProps> = props => {
  const { data, pagination } = agentService.getDataFromJson(props.agent_roles.agent_roles)
  const [agentRoles, setAgentRoles] = React.useState(data)
  const [statusFilter, setStatusFilter] = React.useState('all')

  const filteredRoles = React.useMemo(() => {
    if (statusFilter === 'all') {
      return agentRoles
    }
    return agentRoles.filter(
      r => r.status_label === (statusFilter === 'active' ? 'Active' : 'Disabled')
    )
  }, [agentRoles, statusFilter])

  const handleDelete = React.useCallback(
    async id => {
      try {
        const response = await agentService.deleteAgentRole(id)
        window.flashMessages.addMessage({
          text: response.data.flush.message,
          type: response.data.flush.type,
        })
        setAgentRoles(agentRoles.filter(r => r.id !== id))
      } catch (e) {
        if (e.response?.data?.errors) {
          window.flashMessages.addMessage({
            text: e.response.data.errors,
            type: 'error',
          })
        }
      }
    },
    [agentRoles]
  )

  return (
    <AgentLayoutIndex
      model="agent_roles"
      title={
        <Heading>
          <span>{I18n.t('generic.agent_roles')}</span>
          <Button small={true}>
            <a href="/agent/agent_roles/new">{I18n.t('generic.create_new')}</a>
          </Button>
          <Button small={true}>
            <a href="/agent/agent_roles/permissions_matrix">権限マトリクス一覧</a>
          </Button>
        </Heading>
      }
      main={
        <>
          <StatusFilter>
            {STATUS_OPTIONS.map(opt => (
              <FilterButton
                key={opt.value}
                active={statusFilter === opt.value}
                onClick={() => setStatusFilter(opt.value)}
              >
                {opt.label}
              </FilterButton>
            ))}
          </StatusFilter>
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={filteredRoles}
            pagination={pagination}
            handleDelete={handleDelete}
            getEditLink={({ id }) => `/agent/agent_roles/${id}/edit`}
            renderRecordControls={record => (
              <Button small={true}>
                <a href={`/agent/agent_roles/${record.id}/permissions`}>
                  {I18n.t('generic.agent_permissions')}
                </a>
              </Button>
            )}
          />
        </>
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

const StatusFilter = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`

const FilterButton = styled.button<{ active: boolean }>`
  padding: 6px 16px;
  border: 1px solid ${p => (p.active ? constants.COLORS.primary : '#ccc')};
  border-radius: 20px;
  background: ${p => (p.active ? constants.COLORS.primary : '#fff')};
  color: ${p => (p.active ? '#fff' : '#333')};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    opacity: 0.8;
  }
`

export default AgentRolesIndex
